import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from 'classnames';

import { DatabaseMgmt } from "../../../../services/DatabaseService/DatabaseMgmt";

import userimg from "../../../../../src/assets/images/users/user-dummy-img.jpg";
import { RestroUserLogData } from "../../../../services/DatabaseService/RestroUserLogData";
import { Link, useParams } from "react-router-dom";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { formatDateTime } from "../../../../Components/Common/FormatDate";
import Detail from "./../../../../OrderingSystem/Customer/Components/Detail";
import Section from "../../component/Section";
import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";
import classNames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import ContactPersonForm from "../../RestroUsersInfo/component/ContactPersonForm";

export default function RestroUserLogsDetail() {

  const { apiKey } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [userData, setUserData] = useState(null);

  const [contactModalOpen, setContactModalOpen] = useState(false);

  const toggleContactModal = () => {
    setContactModalOpen(!contactModalOpen);
  }

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      try {
        const [userResult, dataResult] = await Promise.all([
          RestroUsers.getByApiKey(apiKey),
          RestroUserLogData.getByApiKey(apiKey),
        ]);
        setUserData(userResult);
        setDataList(dataResult || []);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, [apiKey]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const result = await RestroUserLogData.getByApiKey(apiKey);
  //       setDataList(result);
  //     } catch (error) {
  //       console.error("Failed to load data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // // useEffect(()=>{
  // //   const fetchData = async () =>{
  // //     try {
  // //       const results = await RestroUsers.getAll();
  // //       setdata(results);
  // //     } catch (error) {
  // //       console.error("Failed to load data: ",error);
  // //     } finally {
  // //       setloading(false);
  // //     }
  // //   }
  // })

  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  console.log(dataList);
  const [filterText, setFilterText] = useState("");
  const [addModal, setAddModal] = useState(false);


  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = dataList.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );
  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
    {
      name: "S No",
      selector: (row, index) => index + 1,
      width: "90px",
      sortable: true,
    },
    {
      name: "Log In Time",
      selector: (row) => formatDateTime(row.logTime),
      width: "275px",
      sortable: true,
    },
    {
      name: "Log For",
      selector: (row) => row.logFor,
      width: "175px",
      sortable: true,
    },
    {
      name: "Detail",
      selector: (row) => <span title={row.logDetails}>{row.logDetails}</span>,
      // width: "280px",
      sortable: true,
    },
    {
      name: "status",
      selector: (row) => row.status,
      sortable: true,
      width: "125px",
      cell: (row) => (
        <span
          className={`badge ${row.status ? "bg-success" : "bg-danger"}`}
        // onClick={() => console.log("Button clicked for", row)}
        >
          {row.status ? "Success" : "Faliure"}
        </span>
      ),
    },
    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div>
    //       <Button
    //         color="btn btn-soft-warning"
    //         className="btn-sm ms-1"
    //         // onClick={() => {
    //         //   setAddModal(true);
    //         //   // setSelectedCustomer(row);
    //         // }}
    //       >
    //         <i className="ri-edit-line" />
    //       </Button>
    //       <Button
    //         className="btn btn-soft-danger btn-sm ms-1"
    //         color="danger"
    //         // onClick={() => handleDeleteClick(row.id)}
    //       >
    //         <i className="ri-delete-bin-5-line" />
    //       </Button>
    //     </div>
    //   ),
    //   center: true,
    // },
  ];

  return (
    <div className="page-content ">
      <div className="container-fluid">
        <BreadCrumb title="Restro User Log List" pageTitle="Details" />
        <Row>
          <Col lg={12}>
            <Card className="mt-n4 mx-n4">
              <div className="bg-warning-subtle">
                <CardBody className="pb-0 px-4">
                  <Row className="mb-3">
                    <div className="col-md">
                      <Row className="align-items-center g-3">
                        <div className="col-md-auto">
                          <div className="avatar-md">
                            <div className="avatar-title bg-white rounded-circle">
                              <img src={userimg} alt="" className="avatar-xs" />
                            </div>
                          </div>
                        </div>
                        <div className="col-md">
                          <div>
                            <h4 className="fw-bold">
                              {userData?.tenantName ||
                                "Tenant Name Unavailable"}{" "}
                            </h4>
                            <div className="hstack gap-3 flex-wrap fs-9 text-muted">
                              <div>
                                <i className="ri-building-line align-bottom me-1 text-muted"></i>{" "}
                                {userData?.tenantCode}
                              </div>
                              <div className="vr"></div>
                              <div>
                                Registered Date :{" "}
                                <span className="fw-medium">
                                  {formatDateTime(userData?.regsiteredDate)}
                                </span>
                              </div>
                              <div className="vr"></div>
                              <div>
                                Valid Till :{" "}
                                <span className="fw-medium">
                                  {formatDateTime(userData?.validTill)}
                                </span>
                              </div>
                              <div className="vr"></div>
                              <div>
                                Address :{" "}
                                <span className="fw-medium">
                                  {userData?.address}
                                </span>
                              </div>
                              <div className="vr"></div>
                              <br />
                              <div>
                                Status :{" "}
                                <span
                                  className={`badge rounded-pill ms-1 ${userData?.isActive
                                    ? "bg-success-subtle text-success"
                                    : "bg-danger-subtle text-danger"
                                    }`}
                                >
                                  {userData?.isActive ? "Active" : "Inactive"}
                                </span>
                              </div>
                              <div className="vr"></div>
                              {/* <Link to={`/contactperson`}>
                                <Button color="btn btn-soft-success" className="btn-sm ms-1">
                                  Contact Person
                                </Button>
                              </Link> */}

                              {/* <div className="vr"></div>
                                                        <div className="badge  bg-info fs-12">New</div>
                                                        <div className="badge  bg-danger fs-12">High</div> */}
                            </div>
                          </div>
                        </div>
                      </Row>
                    </div>
                    <div className="col-md-auto">
                      <div className="hstack gap-1 flex-wrap">
                        {/* <Link to={`/contactdetails`}> */}
                        {/* <Button color="btn btn-success"  className="btn-sm ms-1 border-0" onClick={toggleContactModal}>
                          Contact Person
                        </Button> */}
                        {/* </Link> */}
                        {/* <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-share-line"></i>
                        </button>
                        <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-flag-line"></i>
                        </button> */}
                      </div>
                    </div>
                  </Row>

                  <Nav className="nav-tabs-custom border-bottom-0" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classNames("nav-link fw-semibold mx-3", { active: activeTab === '1' })}

                        onClick={() => { toggleTab('1'); }}
                        href="#">
                        Logs Details
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' }, "fw-bold")}
                        onClick={() => { toggleTab('2'); }}
                        href="#">
                        {/* ContactDetails */}
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '3' }, "fw-bold")}
                        onClick={() => { toggleTab('3'); }}
                        href="#">
                        Activities
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '4' }, "fw-bold")}
                        onClick={() => { toggleTab('4'); }}
                        href="#">
                        Team
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                </CardBody>
              </div>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={1}>
                {/* <LogDetails/> */}
              </TabPane>
              <TabPane tabId={2}>
                {/* <ContactDetails/> */}
              </TabPane>
            </TabContent>
          </Col>
        </Row>
        <Card className="d-none d-lg-block">
          <CardBody>
            <CustomDataTable
              responsive
              striped
              pagination
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                    ariaLabel="triangle-loading"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData || []}
            />
          </CardBody>
        </Card>
        {loading ? (
          <div className="my-5 d-flex justify-content-center">
            <h5 className="mt-1">Loading...</h5>
          </div>
        ) : (
          <>
            {filteredData?.map((item, index) => (
              <Card
                key={item.id || index}
                className="mb-3 shadow-sm d-block d-lg-none mt-2"
              >
                <CardBody>
                  <Row>
                    <Col xs={10}>
                      <h6 className="mb-2">
                        <strong>S No:</strong> {index + 1}
                      </h6>
                      <h6 className="mb-2">
                        <strong>Log In Time :</strong> {item.logTime}
                      </h6>
                      <h6 className="mb-2">
                        <strong>Log For:</strong> {item.logFor}
                      </h6>
                      <h6 className="mb-2">
                        <strong>Detail:</strong> {item.logDetails}
                      </h6>
                      <h6 className="mb-2">
                        <strong>Status:</strong> {item.status}
                      </h6>
                      {item.status ? (
                        <button
                          className="btn btn-success px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          Active
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger px-1 px-sm-2"
                          onClick={() => setAddModal(true)}
                        >
                          InActive
                        </button>
                      )}
                    </Col>
                    <Col xs={2}>
                      <div>
                        <Dropdown
                          isOpen={item.dropdownOpen || false}
                          toggle={(e) => {
                            e.stopPropagation();
                            setDataList((prev) =>
                              prev.map((dbItem) =>
                                dbItem.id === item.id
                                  ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                  : { ...dbItem, dropdownOpen: false }
                              )
                            );
                          }}
                          direction="down"
                        >
                          <DropdownToggle
                            color="primary"
                            outline
                            className="btn-sm shadow-sm rounded-circle"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <DropdownItem
                              onClick={() => {
                                setAddModal(true);
                              }}
                            >
                              <i className="ri-edit-line text-warning me-2"></i>{" "}
                              Edit
                            </DropdownItem>
                            <DropdownItem>
                              <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </>
        )}
        <ContactPersonForm
          modalOpen={contactModalOpen}
          toggleModal={toggleContactModal}
        />
      </div>

    </div>
  );
}
